import { authenticatedFetch } from "./authenticatedFetch";
import { formatApiErrorMessage } from "../utils/apiErrorMessage";
import {
  isHtmlApiResponse,
  parseApiResponseBody,
} from "../utils/parseApiResponseBody";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

class UserService {
  async getUserInfo() {
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/get-user`, {
        method: "GET",
        credentials: "include",
      });

      const data = await parseApiResponseBody(response);

      if (!response.ok || isHtmlApiResponse(response, data)) {
        return {
          success: false,
          error: formatApiErrorMessage(
            data,
            "Não foi possível carregar os dados do usuário."
          ),
        };
      }

      return {
        success: true,
        data,
      };
    } catch (error) {
      console.error("getUserInfo error:", error);

      return {
        success: false,
        error: formatApiErrorMessage(
          error,
          "Não foi possível carregar os dados do usuário."
        ),
      };
    }
  }

  async deleteAccount() {
    const response = await authenticatedFetch(`${API_BASE_URL}/users/delete`, {
      method: "POST",
      credentials: "include",
    });

    if (!response.ok) {
      const errorBody = await parseApiResponseBody(response);

      return {
        success: false,
        status: response.status,
        error: formatApiErrorMessage(
          errorBody,
          "Não foi possível excluir a conta."
        ),
      };
    }

    return {
      success: true,
      status: response.status,
    };
  }

  async loadUserConfigurations() {
    try {
      const response = await authenticatedFetch(
        `${API_BASE_URL}/get-user-configuration`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      if (response.ok) {
        const body = await parseApiResponseBody(response);
        if (isHtmlApiResponse(response, body)) {
          console.error("Erro ao carregar configuracao: resposta HTML");
          return null;
        }
        return body;
      }

      console.error("Erro ao carregar configuracao:", response);
      return null;
    } catch (error) {
      console.error("Erro ao carregar configuracao:", error);
      return null;
    }
  }

  async saveUserConfigurations(payload) {
    try {
      const url = `${API_BASE_URL}/update-user-configuration`;
      const response = await authenticatedFetch(url, {
        method: "POST",
        credentials: "include",
        body: payload,
      });

      const data = await parseApiResponseBody(response);

      if (!response.ok || isHtmlApiResponse(response, data)) {
        const message = formatApiErrorMessage(
          data,
          "Não foi possível salvar as configurações."
        );
        return {
          success: false,
          error: data,
          message,
        };
      }

      if (!response.headers.get("apigw-requestid") && import.meta.env.PROD) {
        console.warn(
          "saveUserConfigurations: response missing apigw-requestid — request may not have reached API Gateway.",
          {
            url,
            status: response.status,
            contentType: response.headers.get("content-type"),
          }
        );
      }

      return { success: true, data };
    } catch (error) {
      const message = formatApiErrorMessage(
        error,
        "Não foi possível salvar as configurações."
      );
      return {
        success: false,
        error: message,
        message,
      };
    }
  }
}

export default new UserService();
